import { Typography, Input, Row, Col } from "antd";
import { useFormContext, Controller } from "react-hook-form";

const { Text } = Typography;

type PrincipalContactsSectionProps = {
  prefix: string;
};

const phoneRegex = /^\+?\d[\d()\-\s]{7,}\d$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function CustomerContacts({ prefix }: PrincipalContactsSectionProps) {
  const { control } = useFormContext<any>();

  return (
    <fieldset>
      <div className="text-lg font-medium mb-2">Контактные данные принципала</div>

      {/* ФИО — одна строка, 3 колонки */}
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Text>Фамилия:</Text>
          <Controller
            name={`${prefix}.attributes.principalContactLastName` as const}
            control={control}
            render={({ field }) => (
              <Input {...field} placeholder="контактный" allowClear autoComplete="family-name" />
            )}
          />
        </Col>

        <Col xs={24} md={8}>
          <Text>Имя:</Text>
          <Controller
            name={`${prefix}.attributes.principalContactFirstName` as const}
            control={control}
            render={({ field }) => (
              <Input {...field} placeholder="контакт" allowClear autoComplete="given-name" />
            )}
          />
        </Col>

        <Col xs={24} md={8}>
          <Text>Отчество:</Text>
          <Controller
            name={`${prefix}.attributes.principalContactSecondName` as const}
            control={control}
            render={({ field }) => (
              <Input {...field} placeholder="принципалович" allowClear autoComplete="additional-name" />
            )}
          />
        </Col>
      </Row>

      {/* Телефон и Email — одна строка, 2 колонки */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} md={12}>
          <Text>Телефон:</Text>
          <Controller
            name={`${prefix}.attributes.principalContactPhone` as const}
            control={control}
            rules={{ validate: (v) => !v || phoneRegex.test(v) || "Введите корректный номер телефона" }}
            render={({ field, fieldState }) => (
              <div>
                <Input {...field} placeholder="+7(985)743-89-57" allowClear autoComplete="tel" />
                {fieldState.error && (
                  <div className="mt-1"><Text type="danger">{fieldState.error.message}</Text></div>
                )}
              </div>
            )}
          />
        </Col>

        <Col xs={24} md={12}>
          <Text>Email:</Text>
          <Controller
            name={`${prefix}.attributes.principalContactEmail` as const}
            control={control}
            rules={{ validate: (v) => !v || emailRegex.test(v) || "Введите корректный email" }}
            render={({ field, fieldState }) => (
              <div>
                <Input {...field} placeholder="mail@principal.ru" allowClear autoComplete="email" />
                {fieldState.error && (
                  <div className="mt-1"><Text type="danger">{fieldState.error.message}</Text></div>
                )}
              </div>
            )}
          />
        </Col>
      </Row>
    </fieldset>
  );
}
